import { useCallback } from 'react';
import Echo from 'laravel-echo';
import { accountFavoritesActions } from '../../components/account/favorite/accountFavoritesSlice.ts';
import { IFavoriteDto, mapIFavoriteDtoToModel } from '../../response/account/getMeResponse.ts';
import { IPrivateChannelArgs, useUserPrivateChannel } from './useUserPrivateChannel.ts';

interface IProps {
    echo: Echo<'pusher'> | null;
}

export const useAccountFavoritesListener = ({ echo }: IProps) => {
    const registerNotifications = useCallback(({ privateChannel, dispatch }: IPrivateChannelArgs) => {
        privateChannel?.listen('.favorites.updated', (data: { id: string, favorites: IFavoriteDto[] }) => {
            const favorites = data.favorites.map((favorite) => mapIFavoriteDtoToModel(favorite));
            dispatch(accountFavoritesActions.updateAll({ favorites: favorites }));
        });
    }, []);

    useUserPrivateChannel({ echo, registerListeners: registerNotifications });
};